var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 13.9998C11.3135 13.9998 13.9998 11.3135 13.9998 7.99984C13.9998 4.68613 11.3135 1.99984 7.99984 1.99984C4.68613 1.99984 1.99984 4.68613 1.99984 7.99984C1.99984 11.3135 4.68613 13.9998 7.99984 13.9998ZM7.99984 15.3332C12.0499 15.3332 15.3332 12.0499 15.3332 7.99984C15.3332 3.94975 12.0499 0.666504 7.99984 0.666504C3.94975 0.666504 0.666504 3.94975 0.666504 7.99984C0.666504 12.0499 3.94975 15.3332 7.99984 15.3332ZM7.99984 3.99984C8.36803 3.99984 8.6665 4.29831 8.6665 4.6665V8.99984C8.6665 9.36803 8.36803 9.6665 7.99984 9.6665C7.63165 9.6665 7.33317 9.36803 7.33317 8.99984V4.6665C7.33317 4.29831 7.63165 3.99984 7.99984 3.99984ZM7.99984 11.9998C8.36803 11.9998 8.6665 11.7014 8.6665 11.3332C8.6665 10.965 8.36803 10.6665 7.99984 10.6665C7.63165 10.6665 7.33317 10.965 7.33317 11.3332C7.33317 11.7014 7.63165 11.9998 7.99984 11.9998Z",
    fill: "#AD640E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncomplete);
export default __webpack_public_path__ + "static/media/ic_incomplete.7ac72f94ba2bbe9da83ca8ac8c6bcbc1.svg";
export { ForwardRef as ReactComponent };